import React from 'react';
import MultiSelectChips from './MultiSelectChips';
import {
  SECTORS,
  IPO_STATUSES,
  REVENUE_RANGES,
  EMPLOYEE_RANGES,
  FUNDING_TYPES,
  FUNDING_TOTAL_RANGES,
} from '../../../Utils/filterOptions';

/**
 * Filter step body — five multi-select chip groups (Sector required) plus a
 * free-text "Additional details" box. Values come from the shared taxonomy
 * module; selection state lives in the parent (useReportsMode).
 */
const FilterStep = ({ filters, toggleFilter, setContext }) => {
  return (
    <div className="reports-filter-step">
      <MultiSelectChips
        label="Sector"
        required
        options={SECTORS}
        selected={filters.sectors}
        onToggle={(v) => toggleFilter('sectors', v)}
      />
      <MultiSelectChips
        label="IPO Status"
        options={IPO_STATUSES}
        selected={filters.ipoStatus}
        onToggle={(v) => toggleFilter('ipoStatus', v)}
      />
      <MultiSelectChips
        label="Revenue Range"
        options={REVENUE_RANGES}
        selected={filters.revenueRange}
        onToggle={(v) => toggleFilter('revenueRange', v)}
      />
      <MultiSelectChips
        label="Employee Count"
        options={EMPLOYEE_RANGES}
        selected={filters.numEmployees}
        onToggle={(v) => toggleFilter('numEmployees', v)}
      />
      <MultiSelectChips
        label="Funding Type"
        options={FUNDING_TYPES}
        selected={filters.fundingType}
        onToggle={(v) => toggleFilter('fundingType', v)}
      />
      <MultiSelectChips
        label="Funding Total"
        options={FUNDING_TOTAL_RANGES}
        selected={filters.fundingTotal}
        onToggle={(v) => toggleFilter('fundingTotal', v)}
      />
      <div className="reports-field">
        <label className="reports-field-label" htmlFor="reports-additional-details">
          Additional details
        </label>
        <textarea
          id="reports-additional-details"
          className="reports-context-input"
          rows={3}
          placeholder="Add any extra context for this report — e.g. focus on companies expanding in EU, recently funded, etc."
          value={filters.context || ''}
          onChange={(e) => setContext(e.target.value)}
        />
      </div>
    </div>
  );
};

export default FilterStep;
